<template>
  <div class="the-navbar__user-meta flex items-center" v-if="activeUser.firstname || activeUser.lastname">
    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ activeUser.firstname }} {{ activeUser.lastname }}</p>
      <small>{{ activeUser.fonction }}</small>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">

      <div class="con-img ml-3">
        <user-avatar :src="activeUser.avatar" />
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">

          <li @click="profile" class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
              <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
              <span class="ml-2">Profile</span>
          </li>

          <!-- <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
            <feather-icon icon="MailIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Inbox</span>
          </li>

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
            <feather-icon icon="CheckSquareIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Tasks</span>
          </li>

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
            <feather-icon icon="MessageSquareIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Chat</span>
          </li>

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
            <feather-icon icon="HeartIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Wish List</span>
          </li> -->

          <vs-divider class="m-1" />

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Quitter</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import UserAvatar from '@/components/UserAvatar'

export default {
  components: {
    UserAvatar
  },
  computed: {
    ...mapGetters('user', ['loggedIn', 'activeUser'])
  },
  methods: {
    ...mapActions('user', ['logout']),
    profile () {
      this.$router.push({ path: '/profile' }).catch(() => {})
    }
  },
  created () {
    if (!this.loggedIn) {
      this.logout()
    }
  }
}
</script>
